module.exports = __webpack_public_path__ + "static/media/IllusChallenges.83480b80.png";